import { createContext } from "react";

export interface AppState {
  openSnackbar: (content: string, severity: string) => void;
}

export const AppContext = createContext<AppState>({
  openSnackbar: (content, severity) => {},
});
